import React from 'react';

const SideArrow = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.2789 2.77188L2.94097 2.77188L2.82768 2.77687C2.08764 2.85129 1.54244 3.45114 1.54244 4.17041L1.54743 4.28371L1.5616 4.38806C1.67925 5.07443 2.25595 5.56894 2.94097 5.56894L8.9028 5.56866L2.73022 11.7412L2.6579 11.8198C2.18287 12.3942 2.21944 13.2083 2.73022 13.7191L2.79735 13.782C3.34668 14.2643 4.18373 14.2434 4.70804 13.7191L10.8802 7.54689L10.8803 13.5083L10.8853 13.6216C10.9597 14.3616 11.5596 14.9068 12.2789 14.9068C13.0513 14.9068 13.6774 14.2807 13.6774 13.5083L13.6774 4.17041L13.6702 4.02811C13.598 3.31708 12.9981 2.77188 12.2789 2.77188Z"
      fill="#6930CA"
    />
  </svg>
);

export default SideArrow;
